<template>
  <div :style="{opacity: opacity}" class="watermarkContainer">
    <div :style="{backgroundImage: `url('${url}')`}" class="watermark" />
  </div>
</template>
<script>
export default {
  name: 'waterMark',
  props: {
    content: {
      required: false,
      default: ''
    },
    showSimple: {
      required: false,
      default: false
    },
    opacity: {
      required: false,
      default: 1
    }
  },
  computed: {
    showText: function () {
      if (this.content) {
        return this.content
      } else {
        let user = this.$store.getters['userInfo/user'] || {}
        console.log('this.$store.state.user', user)
        // let name = user.account || user.name
        return user.name + "【" + user.account + "】"
      }
    },
    subText: function () {
      return this.$moment().format("YYYY-MM-DD HH:mm:ss")
    }
  },
  data () {
    return {
      url: ''
    }
  },
  created () {
    this.createWatermark()
  },
  methods: {
    createWatermark () {
      let canvas = document.createElement('canvas')
      canvas.style.background = 'transparent'
      let ctx = canvas.getContext('2d')
      if (this.showSimple) {
        let width1 = ctx.measureText(this.showText).width
        let width = width1 * 2.5
        let height = 36 * 2.5

        canvas.setAttribute('width', width)
        canvas.setAttribute('height', height)

        // 设置字体
        ctx.font = "14px 微软雅黑 "
        // 设置字体颜色
        ctx.fillStyle = "#ccc"
        ctx.textAlign = "center"
        ctx.textBaseline = 'middle'
        // 添加文字和位置
        ctx.translate(width / 4, 20)
        ctx.rotate(-30 * Math.PI / 180)
        ctx.fillText(this.showText, 0, height / 3)
        ctx.setTransform(1, 0, 0, 1, 0, 0)

      } else {
        let width1 = ctx.measureText(this.showText).width
        let width2 = ctx.measureText(this.subText).width

        let width = (width1 > width2 ? width1 : width2) * 2
        let height = 36 * 4
        console.log('width', width)
        canvas.setAttribute('width', width)
        canvas.setAttribute('height', height)

        // 设置字体
        ctx.font = "14px 微软雅黑 "
        // 设置字体颜色
        ctx.fillStyle = "#c1c1c1"
        ctx.textAlign = "center"
        ctx.textBaseline = 'middle'
        // 添加文字和位置
        ctx.translate(width / 3, 20)
        ctx.rotate(-30 * Math.PI / 180)
        ctx.fillText(this.showText, 0, height / 3)

        ctx.font = "12px 微软雅黑 "
        ctx.fillStyle = "#ccc"
        ctx.fillText(this.subText, 0, height / 2)
        ctx.setTransform(1, 0, 0, 1, 0, 0)
      }



      // 导出为图片
      this.url = canvas.toDataURL("image/png")
    }
  }
}
</script>
<style lang="less" scoped>
.watermarkContainer {
  user-select: none;
  pointer-events: none;
  position: absolute;
  opacity: 1;
  left: 0;
  right: 0;
  // bottom: 0;
  opacity: 0.6;
  top: 0;
  z-index: 999;
  // overflow: hidden;
  height: 100%;
  width: 100%;

  .watermark {
    background-image: 'XXX';
    background-repeat: space;
    background-position: center;
    height: 100%;
    width: 100%;
  }
}
</style>